export enum ETypeVegetation
{
    ArbustiveArboree = 1,
    Herbacee,
    Exotique,
    LigneusePlantee,
    Culture,
    Absence
}
